<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="16">
        <div style="display: flex; justify-content: space-between">
          <div>
            <el-popconfirm
              title="要新增品种，请在右侧表单中填写信息"
              @confirm="addEmployee"
              @cancel="cancel"
            >
              <el-button type="primary" slot="reference" size="mini">
                新增
              </el-button>
            </el-popconfirm>
          </div>
          <div>
            <el-input
              v-model="plantName"
              placeholder="品种名称"
              style="width: 74%"
              size="mini"
            />
            <el-button type="primary" @click="search" size="mini">
              搜索
            </el-button>
          </div>
        </div>
        <el-table :data="varieties" height="640">
          <el-table-column prop="id" label="编号" width="60" />
          <el-table-column prop="name" label="品种名称" width="100" />
          <el-table-column prop="descr" label="描述" />
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="编辑"
                placement="top"
              >
                <el-button
                  type="warning"
                  circle
                  size="large"
                  style="padding: 4px"
                  icon="el-icon-edit"
                  @click="update(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="删除"
                placement="top"
              >
                <el-button
                  icon="el-icon-delete"
                  type="success"
                  circle
                  size="large"
                  style="padding: 4px"
                  @click="remove(scope.row.id)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页控件 -->
        <div style="text-align: center" class="mt-2">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="value"
            layout="total, sizes, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card" style="min-height: 619px">
          <div slot="header" class="clearfix">{{ title }}品种</div>
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            size="small"
            label-width="80px"
          >
            <el-form-item label="品种名称" prop="name">
              <el-input v-model="form.name" maxlength="30" />
            </el-form-item>
            <el-form-item label="描述" prop="descr">
              <el-input
                v-model="form.descr"
                type="textarea"
                :autosize="{ minRows: 6 }"
                maxlength="200"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="warning" size="mini" @click="clearFrom">
                清空
              </el-button>
              <el-button type="primary" size="mini" @click="save">
                填好了，保存
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getVarieties,
  addVariety,
  updateVariety,
  deleteVariety,
  verityNameSearch,
} from '@/api/variety.js'
export default {
  name: 'PersonIndex',
  data() {
    var checkName = (rule, value, callback) => {
      if (value != this.varietyName) {
        verityNameSearch(this.form.name).then((data) => {
          if (!data.data) {
            callback()
          } else {
            callback(new Error('该名称已存在'))
          }
        })
      } else {
        callback()
      }
    }
    return {
      varietyName: '',
      pageNum: 1,
      value: 10,
      total: 0,
      plantId: undefined,
      plantName: null,
      varieties: [],
      activeTab: 'newone',
      form: {
        id: '',
        name: '',
        count: '',
        type: '',
        descr: '',
      },
      rules: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' },
          { validator: checkName, trigger: 'change' },
        ],
        count: [{ required: true, message: '数量不能为空', trigger: 'blur' }],
        type: [{ required: true, message: '种类不能为空', trigger: 'blur' }],
      },
    }
  },
  methods: {
    cancel() {},
    search() {
      if (this.plantName != '') {
        this.vertriSearch()
      } else {
        this.plantName = null
        this.vertriSearch()
      }
    },
    handleSizeChange(val) {
      this.value = val
      this.pageNum = 1
      this.vertriSearch()
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.vertriSearch()
      console.log(`当前页: ${val}`)
    },
    vertriSearch() {
      getVarieties({
        name: this.plantName,
      }).then((resp) => {
        this.varieties = resp.data.list
        this.total = resp.data.total
      })
    },
    addEmployee() {
      this.plantId = undefined
      this.$refs.form.resetFields()
    },
    update(row) {
      this.plantId = row.id
      this.form.id = row.id
      this.form.name = row.name
      this.form.count = row.count
      this.form.type = row.type
      this.form.descr = row.descr
      this.varietyName = row.name
    },
    clearFrom() {
      this.$refs.form.resetFields()
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.plantId) {
            addVariety(this.form).then((resp) => {
              this.vertriSearch()
              this.$message.success('提交成功')
              this.$refs.form.resetFields()
              this.varietyName = ''
            })
          } else {
            updateVariety(this.form.id, this.form).then((resp) => {
              this.vertriSearch()
              this.$message.success('提交成功')
              this.plantId = undefined
              this.$refs.form.resetFields()
            })
          }
        }
      })
    },
    remove(id) {
      deleteVariety(id).then((resp) => {
        this.$message.success('删除成功')
        this.vertriSearch()
      })
    },
  },
  computed: {
    title: function () {
      console.log(this.plantId)
      return this.plantId ? '编辑' : '新增'
    },
  },
  mounted() {
    this.vertriSearch()
    console.log('【↑↑↑】', this.$options.name)
  },

  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>
<style>
.el-message {
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/plant/variety/Index.vue